export const IBillableShiftsStatus = Object.freeze({
  code: "value",
  label: "text",
  criticity: "color",
  tooltip: "tooltip",
  key: "key",
});

export class BillableShiftsStatusModel {
  constructor(data = {}) {
    this[IBillableShiftsStatus.code] = data[IBillableShiftsStatus.code];
    this[IBillableShiftsStatus.label] = data[IBillableShiftsStatus.label];
    this[IBillableShiftsStatus.criticity] = data[IBillableShiftsStatus.criticity];
    this[IBillableShiftsStatus.tooltip] = data[IBillableShiftsStatus.tooltip];
    this[IBillableShiftsStatus.key] = data[IBillableShiftsStatus.key];
  }

  getCode() {
    return this[IBillableShiftsStatus.code];
  }

  getLabel() {
    return this[IBillableShiftsStatus.label];
  }

  getCriticity() {
    return this[IBillableShiftsStatus.criticity];
  }

  getTooltip() {
    return this[IBillableShiftsStatus.tooltip];
  }

  getKey() {
    return this[IBillableShiftsStatus.key];
  }
}
